require('./OpentypeIText.js');
const { reverseText, getVerticalText } = require('./utils');
const { applyInnerText } = require('./inner-text');
const {
    constrainPositionToBoundingBox,
    constrainDimensionToBoundingBox,
    constrainRotationToBoundingBox
} = require('../utils/geometryUtils.js');
const { DEFAULT_SHADOW_FILL } = require('../utils/shadowDefaults.js');

fabric.BoundedText = fabric.util.createClass(fabric.Group, {
    cacheProperties: fabric.Group.prototype.cacheProperties.concat(
        'textVerticalAlign',
        'textAlign',
        'caps',
        'outlineWidth',
        'fontFamily',
        'fillPattern',
        'version',
        'lineSpacing',
        'ligatures',
        'tracking',
        'fontSize',
        'multiline',
        'minSizePx',
        'maxSizePx',
        'prefix',
        'suffix',
        'betweenCharacters',
        'betweenWords',
        'referenceId',
        '_textWithoutPrefixSuffix',
        'allowEdit',
        'useAsMask',
        'useAsCutout',
        'verticalText',
        'textShape'
    ),

    async: true,
    type: 'bounded-text',
    lockUniScalingWithSkew: false,
    caps: false,

    debug: false,
    version: '2.0.0',
    Itext: false,
    textVerticalAlign: 'center',

    lineSpacing: 1,
    betweenCharacters: '',
    betweenWords: '',
    _textWithoutPrefixSuffix: '',

    _controlRectangle: null,
    silentEditMode: false,
    preventEditMode: false,
    _forcedEditMode: false,
    _editMode: false,
    _enablingEditMode: false,
    _editModeDataBackup: {},
    rotationStep: 1, // Rotation step in degrees for edit mode
    rectangleEventsSet: false,
    forcedFontSize: false,
    textTransformed: false,

    initialize: function (options) {
        // Sanitize the font family name before assigning it to any element
        if (options.fontFamily) {
            options.fontFamily = this._sanitizeFontFamily(options.fontFamily);
        }

        // Make sure we have a valid version
        options.version = options.version || fabric.BoundedText.prototype.version;
        options.width = options.width || 300;
        options.height = options.height || 300;

        const constructorParameters = {
            width: options.width,
            height: options.height,
            fontSize: options.fontSize || 200,
            originX: 'center',
            originY: 'center',
            textAlign: options.textAlign || 'center',
            centeredRotation: true,
            color: options.color || 'black',
            fontFamily: options.fontFamily || 'Arial',
            backgroundColor: this.debug ? '#f7dacf' : 'rgba(0,0,0,0)',
            tracking: options.tracking || 0,
            version: options.version,
            calculateDimensions: false,
            splitText: false,
            shadowType: options.shadowType,
            shadowOffset: options.shadowOffset || 0,
            shadowAngle: options.shadowAngle || 0,
            shadowBlur: options.shadowBlur || 0,
            shadowColorOption: options.shadowColorOption || 1,
            shadowColorLibraryId: options.shadowColorLibraryId || null,
            shadowColorsMap: options.shadowColorsMap || new Map(),
        };

        const text = new fabric.OpentypeIText('', constructorParameters);
        text.set('maxWidth', options.width);
        text.set('maxHeight', options.height);

        const boundsRectangle = new fabric.Rect({
            strokeDashArray: options.strokeDashArray,
            originX: 'center',
            originY: 'center',
            stroke: '#000000',
            strokeWidth: 3,
            width: options.width,
            height: options.height,
            fill: 'rgba(0, 0, 0, 0)'
        });

        this._controlRectangle = new fabric.Rect({
            originX: 'center',
            originY: 'center',
            strokeWidth: 3,
            fill: 'rgba(0, 0, 0, 0)',
            lockScalingFlip: true
        });

        const isMobile = !!options.isMobile;
        this._controlRectangle.setControlsVisibility({
            tl: !isMobile,
            tr: !isMobile,
            br: !isMobile,
            bl: !isMobile,
            mtr: !isMobile,

            ml: false,
            mb: false,
            mr: false,
            mt: false
        });

        this.callSuper('initialize', [text, boundsRectangle], options);
        this.setTextAlign(options.textAlign || 'center');
        this.setTextVerticalAlign(options.textVerticalAlign || 'center');
        this.set('angle', options.angle);

        if (options.allowEdit) {
            text.set('left', options.initCenterX || text.left);
            text.set('top', options.initCenterY || text.top);
            text.set('angle', options.initRotation || text.angle);
            if (options.initFontSize) {
                this.forceFontSize(options.initFontSize);
            }
            this.textTransformed = true;
        }

        this.setText(options.Itext ? 'ם' : 'A');

        if (options.textPath) {
            // Loaded from a saved product/template: the stored path is already the
            //  size-independent "unit path" setTextPath() normalizes new paths into (see
            //  clone(), which restores it the same way), so it must NOT be re-normalized here.
            //  textPathDebug is a dev-only visualization aid, not persisted.
            this.setTextPath(options.textPath, options.textPathAutoFit !== false, false, {
                normalize: false
            });
        }

        this.shapeConfig = options.shapeConfig || null;

        this.on({
            // Override the scaling behavior to change the width and height instead of
            //  applying scaling to the object
            scaling: function (event) {
                // Only allow proportional scaling but allowing skew
                if (this.lockUniScalingWithSkew) {
                    let scale = 1;
                    if (event.transform.action === 'scaleX') {
                        scale = this.scaleX;
                    } else {
                        scale = this.scaleY;
                    }

                    this.scaleX = scale;
                    this.scaleY = scale;
                }
            },
            scaled: function () {
                this.setScale(this.width, this.height, false);
            },
            // Scale font when the object is added
            added: function () {
                this.cornerSize = 0.025 * this.canvas.width;
                this.transparentCorners = false;
            },
            removed: function () {
                this.canvas.remove(this._controlRectangle);
            },
            deselected: function () {
                // The pen takes over canvas selection/cursor, which must not outlive the selection
                if (this.isDrawingTextPath) {
                    this.finishTextPathPen({ edit: false });
                }

                // "Draw on Path" point editor: leaving its draggable controls attached to a
                //  deselected object is confusing (and they'd keep referencing stale coordinates
                //  if the object moves/resizes while not selected)
                if (this.isEditingTextPath) {
                    this.disableTextPathEditor();
                }

                // When edit mode was forced (calling enableEditMode()) don't disable edit mode
                //  on deselection
                if (this._editMode && !this._forcedEditMode && !this._enablingEditMode) {
                    this._editMode = false;
                    this.canvas.selection = this._editModeDataBackup.originalCanvasSelection;
                    this.canvas.remove(this._controlRectangle);

                    // Restore controls
                    this.setControlsVisibility(this._editModeDataBackup.controlsVisibilityBackup);

                    // Restore movement lock
                    this.lockMovementX = this._editModeDataBackup.originalLockX;
                    this.lockMovementY = this._editModeDataBackup.originalLockY;
                    if (!this.silentEditMode) {
                        this.item(1).set('stroke', this._editModeDataBackup.originalStroke);
                        this.item(1).set('strokeWidth', this._editModeDataBackup.originalStrokeWidth);
                        this.set('dirty', true);
                    }

                    this.canvas.renderAll();
                }
            },
            selected: function () {
                if (!this.rectangleEventsSet) {
                    this.setDblclickEvent(this);
                    this.setControlRectangleEvents(this);
                    this.rectangleEventsSet = true;
                }
            }
        });

        if (!options.skipRectangleEventsOnInit) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const scope = this;
            this.setDblclickEvent(scope);
            this.setControlRectangleEvents(scope);
            this.rectangleEventsSet = true;
        }
    },
    setDblclickEvent: function (scope) {
        this.on({
            'object:dblclick': function () {
                if (!this.preventEditMode && this.allowEdit) {
                    this._editMode = true;
                    this._enablingEditMode = true;

                    // Disable canvas selection
                    this._editModeDataBackup.originalCanvasSelection = this.canvas.selection;
                    this.canvas.selection = false;

                    // Make sure we can't use the controls when the mouse is over even when they are
                    //  not drawn
                    this._editModeDataBackup.controlsVisibilityBackup = JSON.parse(
                        JSON.stringify(this._getControlsVisibility())
                    );
                    this.setControlsVisibility({
                        bl: false,
                        br: false,
                        mb: false,
                        ml: false,
                        mr: false,
                        mt: false,
                        mtr: false,
                        tl: false,
                        tr: false
                    });

                    // Match selection settings
                    this._controlRectangle.set('cornerSize', this.cornerSize);
                    this._controlRectangle.set('transparentCorners', this.transparentCorners);
                    this._controlRectangle.set('centeredScaling', true);
                    this._controlRectangle.set('centeredRotation', true);
                    this._controlRectangle.set('zIndex', this.zIndex + 1);

                    // Update _controlRectangle properties to fit with text rectangle
                    const centerPoint = this.item(0).getCenterPoint();
                    const absolutePoint = fabric.util.transformPoint(centerPoint, scope.calcTransformMatrix());
                    const absoluteAngle = this.angle + this.item(0).angle;

                    this._controlRectangle.set('left', absolutePoint.x);
                    this._controlRectangle.set('top', absolutePoint.y);
                    this._controlRectangle.set('width', this.item(0).width);
                    this._controlRectangle.set('height', this.item(0).height);
                    this._controlRectangle.set('skewX', this.skewX);
                    this._controlRectangle.set('skewY', this.skewY);
                    this._controlRectangle.set('angle', absoluteAngle);
                    this._controlRectangle.setCoords();

                    // Select the bounding rectangle object
                    this.canvas.add(this._controlRectangle);
                    this.canvas.setActiveObject(this._controlRectangle);

                    // Block object movement
                    this._editModeDataBackup.originalLockX = this.lockMovementX;
                    this._editModeDataBackup.originalLockY = this.lockMovementY;
                    this.lockMovementX = this.lockMovementY = true;

                    if (!this.silentEditMode) {
                        // Make the stroke red
                        this._editModeDataBackup.originalStroke = this.item(1).stroke;
                        this._editModeDataBackup.originalStrokeWidth = this.item(1).strokeWidth;

                        this.item(1).set('stroke', 'red');
                        this.item(1).set('strokeWidth', 5);
                    }

                    this._enablingEditMode = false;
                    this.canvas.requestRenderAll();
                }
            }
        });
    },

    setControlRectangleEvents: function (scope) {
        this._controlRectangle.on({
            selected: function () {
                scope.lastAngle = this.angle;
            },
            deselected: function (e) {
                scope.fire('deselected', e);
            },
            moving: function () {
                const params = scope.getEditModeParameters();
                scope.setTextOffset(params.offsetX, params.offsetY);
                scope.refreshTextIfCharsWereDeleted();
                scope.setEditedProp?.('innerText');
            },
            rotating: function () {
                const params = scope.getEditModeParameters();
                scope.setTextRotation(params.angle);
                scope.refreshTextIfCharsWereDeleted();
                scope.setEditedProp?.('innerText');
            },
            scaling: function () {
                const params = scope.getEditModeParameters();
                scope.setTextScale(params.scaleX, params.scaleY);
                scope.refreshTextIfCharsWereDeleted();
                scope.setEditedProp?.('innerText');
            }
        });
    },

    refreshTextIfCharsWereDeleted: function () {
        if (this.item(0).deletedChars) {
            /*If a text with characters removed goes through a transformation,
              we rewrite the text to see if the removed characters now fit.*/
            this.setText(this.getText());
        }
    },

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions: function () {
        const dims = this.callSuper('_getCacheCanvasDimensions');
        // Give some margin to the cache canvas heigh so fonts that go outside the bounds get rendered anyways (fonts shouldn't
        //  go outside but the vertical alignment of the previous implementation works that way so we cannot change that as we
        //  need to keep the same behaviour)
        dims.height = this.height * 2 * dims.zoomY;
        if (this.item(0) && this.item(0).textPath) {
            // "Draw on Path" text can stick out sideways well past the nominal box (rotated
            //  glyphs near steep sections of the curve), unlike normal horizontal text which
            //  stays within maxWidth - width doesn't get the same margin height does above, so
            //  an undersized cache canvas clips those glyphs and/or leaves stale pixels on the
            //  main canvas (fabric uses these dims to know what screen region to redraw/clear).
            dims.width = this.width * 2 * dims.zoomX;
        }
        if (this.shadowType != null) {
            //Give margin to the cache canvas so shadow that go outside the bounds get rendered anyways
            const textItem = this.item(0);
            // Path-mode's raw fontSize can be exactly 0 on reload (see calculateShadowFill()'s
            //  fontSizeOverride comment) - fall back the same way _renderTextAlongPath does.
            const shadow = textItem && textItem.calculateShadowFill(textItem.fontSize || 200);
            if (shadow) {
                dims.width += 2 * (Math.abs(shadow.offsetX) + shadow.blur);
                dims.height += 2 * (Math.abs(shadow.offsetY) + shadow.blur);
            }
        }
        return dims;
    },

    /**
     * This method is intended to be called after the object was modified with a group
     *  selection. On fabric.js, elements events are not fired when inside a group, that's
     *  why this method must be called manually after exiting group selection
     */
    updateFromGroupScaling: function () {
        this.setScale(this.width, this.height, true);
    },

    scaleTextPosition(scale) {
        this.item(0).left = this.item(0).left * scale;
        this.item(0).top = this.item(0).top * scale;
    },

    setScale: function (width, height, alignText) {
        const w = width * this.scaleX,
            h = height * this.scaleY;

        const scaleX = this.scaleX;
        const scaleY = this.scaleY;

        this.scaleX = 1;
        this.scaleY = 1;
        this.setWidth(w);
        this.setHeight(h);

        if (alignText) this.setTextAlign(this.getTextAlign());
    },

    /**
     * Sets specified property to a specified value
     * @param {String} key
     * @param {*} value
     * @chainable
     */
    _set: function (key, value) {
        if (key === 'id') {
            if (this._controlRectangle) {
                this._controlRectangle.id = value;
            }
        } else if (key === 'minSizePx') {
            this.setMinSizePx(value);
        } else if (key === 'maxSizePx') {
            this.setMaxSizePx(value);
        } else if (key === 'textAlign') {
            this.setTextAlign(value);
        } else if (key === 'textVerticalAlign') {
            this.setTextVerticalAlign(value);
        } else if (key === 'caps') {
            this.setCaps(value);
        } else if (key === 'text') {
            this.setText(value);
        } else if (key === 'outlineWidth') {
            this.setOutlineWidth(value);
        } else if (key === 'fontFamily') {
            this.setFontFamily(value);
        } else if (key === 'fill' && value.constructor === fabric.Pattern) {
            this.item(0).set('fillPattern', value);
        } else if (key === 'textureScale') {
            this.item(0).set('textureScale', value);
        } else if (key === 'version') {
            this.item(0).set('version', value);
        } else if (key === 'lineSpacing') {
            this.item(0).set('lineSpacing', value);
        } else if (key === 'ligatures') {
            this.item(0).set('ligatures', value);
        } else if (key === 'multiline') {
            this.setMultiline(value);
        } else if (key === 'verticalText') {
            this.setVerticalText(value);
        } else if (key === 'useAsMask') {
            this.setUseAsMask(value);
        } else if (key === 'useAsCutout') {
            this.setUseAsCutout(value);
        } else if (key === 'allowEdit') {
            // Moving/resizing the text inside the box isn't supported within a text shape
            if (value && this.textShape) {
                value = false;
            }
            if (value) {
                this.item(0).set({ top: 0, left: 0 });
                this.set('textAlign', 'center');
                this.set('textVerticalAlign', 'center');
                this.textTransformed = true;
            }
            this.setAllowEdit(value);
        } else if (key === 'tracking') {
            this.setTrackingAmount(value);
        } else if (key === 'evented') {
            if (this._controlRectangle) {
                this._controlRectangle.set('evented', value);
            }

            // If on edit mode, don't alter the evented attribute from the Text, only from the selection rectangle
            if (this._forcedEditMode || this._editMode) {
                return;
            }
        } else if (key === 'hasControls') {
            if (this._controlRectangle) {
                this._controlRectangle.set('hasControls', value);
            }
        } else if (key === 'width') {
            this.item(0).set('bbWidth', value);
            if (this.item(1)) {
                this.item(1).set('width', value);
            }
        } else if (key === 'height') {
            this.item(0).set('bbHeight', value);
            if (this.item(1)) {
                this.item(1).set('height', value);
            }
        } else if (key === 'shadowType') {
            this.item(0).set(key, value);
        } else if (key === 'shadowOffset') {
            this.item(0).set(key, value);
        } else if (key === 'shadowAngle') {
            this.item(0).set(key, value);
        } else if (key === 'shadowBlur') {
            this.item(0).set(key, value);
        }

        this.callSuper('_set', key, value);

        // Set the new text with suffix and prefix
        if (key === 'prefix' || key === 'suffix' || key === 'betweenCharacters' || key === 'betweenWords') {
            this.setText(this.getText());
        }
    },

    getTextPaths: function (asSvg = false) {
        return this.item(0).getTextPaths(asSvg);
    },

    setTextAlign: function (align) {
        if (this.allowEdit) {
            align = 'center';
        }
        if (this.item(0).type == 'opentype-itext') {
            this.item(0).set('textAlign', align);
        }
    },

    setTextVerticalAlign: function (align) {
        if (this.allowEdit) {
            align = 'center';
        }
        if (this.item(0).type == 'opentype-itext') {
            this.item(0).set('textVerticalAlign', align);
        }
    },

    /**
     * Set the tracking (letter spacing) amount
     * @param {Number} tracking amount of tracking (ie: -20, 50, 200, 0)
     */
    setTrackingAmount: function (tracking) {
        this.item(0).set('tracking', tracking || 0);
    },

    getTrackingAmount: function () {
        return this.item(0).tracking || 0;
    },

    getOutlineWidth: function () {
        return this.item(0).opentypeStrokeWidth || 0;
    },

    setOutlineWidth: function (width) {
        this.item(0).set('opentypeStrokeWidth', width || 0);
    },

    getOutlineColor: function () {
        return this.item(0).opentypeStroke || '#000000';
    },

    setOutlineColor: function (color) {
        this.item(0).set('opentypeStroke', color || '#000000');
    },

    /**
     * Writes a shadow patch in one pass, same contract as the image placeholder (see the
     *  ShadowElement interface the shadow panel is written against). A text has no filter to
     *  rebuild, so each property is a plain set() that the next render picks up.
     */
    applyShadow: function (patch) {
        if (!patch) {
            return;
        }

        // Only the keys present are applied, so one call can carry a whole shadow or a single
        //  slider. _set forwards each one to the inner text, which reads them while it renders.
        if ('shadowOffset' in patch) {
            this.set('shadowOffset', patch.shadowOffset || 0);
        }
        if ('shadowAngle' in patch) {
            this.set('shadowAngle', patch.shadowAngle || 0);
        }
        if ('shadowBlur' in patch) {
            this.set('shadowBlur', patch.shadowBlur || 0);
        }
        if ('shadowFill' in patch) {
            this.setShadowColor(patch.shadowFill);
        }
        if ('shadowType' in patch) {
            this.set('shadowType', patch.shadowType ?? null);
        }
    },

    setShadowColor: function (color) {
        this.item(0).set('shadowFill', color || DEFAULT_SHADOW_FILL);
    },

    getShadowColor: function () {
        return this.item(0).shadowFill || DEFAULT_SHADOW_FILL;
    },

    getTextAlign: function () {
        return this.item(0).textAlign;
    },

    getTextVerticalAlign: function () {
        return this.item(0).textVerticalAlign;
    },

    setCursorColor: function (color) {
        this.item(0).cursorColor = color;
    },

    setStroke: function (stroke) {
        this.item(1).set('stroke', stroke);
    },

    setStrokeWidth: function (width) {
        this.item(1).set('strokeWidth', width);
    },

    getStroke: function () {
        return this.item(1).stroke;
    },

    setColor: function (color) {
        this.item(0).setColor(color);
    },

    getColor: function () {
        return this.item(0).fill;
    },

    getText: function () {
        return this._textWithoutPrefixSuffix;
    },

    getTextWithLines: function () {
        return this.item(0).getText();
    },

    setText: function (text) {
        if (!text) text = '';

        // If the text is rotated, always recalculate its max dimensions.
        // If the text is not rotated, recalculate only if it was moved, resized, or rotated.
        this.item(0).set(
            'calculateDimensions', this.allowEdit && (this.getTextAngle() != 0 || this.textTransformed)
        );

        this.set('_textWithoutPrefixSuffix', text);
        const hasVerticalText = this.verticalText;
        let targetText = hasVerticalText ? getVerticalText(text) : text;

        if (targetText) {
            if (this.caps) {
                targetText = targetText.toUpperCase();
            }
            targetText = applyInnerText(targetText, this.betweenCharacters, this.betweenWords);
            targetText = (this.prefix || '') + targetText + (this.suffix || '');
        }

        if (this.allowEdit) {
            this.checkForcedFontSize(text);
            this.setEditedProp?.('innerText');
        }

        this.item(0).set('text', this.Itext ? reverseText(targetText) : targetText);

        if (this.allowEdit) {
            this.updateControlRectangle();
            if (!Number.isNaN(this.item(0).maxWidth) && !Number.isNaN(this.item(0).maxHeight)) {
                this.item(0).set('calculateDimensions', false);
                this.textTransformed = false;
            }
        }
        return targetText;
    },

    updateControlRectangle: function () {
        // Update _controlRectangle properties to fit with text rectangle
        const centerPoint = this.item(0).getCenterPoint();
        const absolutePoint = fabric.util.transformPoint(centerPoint, this.calcTransformMatrix());
        const absoluteAngle = this.angle + this.item(0).angle;

        this._controlRectangle.set('left', absolutePoint.x);
        this._controlRectangle.set('top', absolutePoint.y);
        this._controlRectangle.set('width', this.item(0).width);
        this._controlRectangle.set('height', this.item(0).height);
        this._controlRectangle.set('angle', absoluteAngle);
        this._controlRectangle.setCoords();
    },

    checkForcedFontSize: function (text) {
        if (
            this.forcedFontSize &&
            this.item(0).isFontSizeBelowMinimum(
                text,
                this.getTrackingAmount(),
                this.item(0).maxWidth,
                this.item(0).maxHeight
            )
        ) {
            /*If the user scales the text, the fontSize may be smaller than the max allowed by maxWidth and maxHeight. To achieve this, we force the fontSize to that value.
            However, if the new font size is smaller than that value, we clear the force so that it takes the minSizePx and maxSizePx values.*/
            this.forceFontSize(false);
        }
    },

    forceFontSize: function (size) {
        if (size) {
            this.item(0).set('maxFontSize', size);
            this.item(0).set('minFontSize', size);
            this.forcedFontSize = true;
        } else {
            this.item(0).set('maxFontSize', this.maxSizePx);
            this.item(0).set('minFontSize', this.minSizePx);
            this.forcedFontSize = false;
        }
    },

    setFontSize: function (size) {
        this.item(0).fontSize = size;
    },

    getFontSize: function () {
        return this.item(0).fontSize;
    },

    _sanitizeFontFamily: function (family) {
        // Add quotes around the font name to avoid issues
        // Read more about this tricky world of the fonts here: https://mathiasbynens.be/notes/unquoted-font-family
        if (family.indexOf("'") < 0) {
            family = "'" + family + "'";
        }
        return family;
    },

    setFontFamily: function (family) {
        family = this._sanitizeFontFamily(family);
        // Keep the wrapper's own fontFamily in sync - callers that invoke this method directly
        //  (bypassing .set()/_set) would otherwise leave it stale, breaking anything that reads
        //  it off the group itself (e.g. engraver.js's text-mask cache fingerprint).
        this.fontFamily = family;
        this.item(0).set('fontFamily', family);
        if (this.allowEdit) {
            if (this.forcedFontSize && this.item(0).fontSize < this.item(0).minFontSize) {
                /*If the user scales the text, the fontSize may be smaller than the max allowed by maxWidth and maxHeight. To achieve this, we force the fontSize to that value.
                However, if the new font size is smaller than that value, we clear the force so that it takes the minSizePx and maxSizePx values.*/
                this.forceFontSize(false);
                this.item(0).set('fontFamily', family);
            }
            this.setText(this.getText());
        }
    },

    getFontFamily: function () {
        return this.item(0).fontFamily;
    },

    setWidth: function (width) {
        if (!width) width = 0;
        let scale;
        if(width > 0 && this.width > 0) {
            scale = width / this.width;
        }
        this.set('width', width);
        this.item(1).set('width', width);
        if (!this.allowEdit) {
            this.item(0).set('maxWidth', width);
        }

        if (this.allowEdit && !this.noScaleTextWithBox && scale) {
            this.forceFontSize(false);
            this.item(0).set('left', this.item(0).left * scale);
            this.textTransformed = true;
            this.setText(this.getText());
            this.setEditedProp?.('innerText');
        }
    },

    getWidth: function () {
        return this.width * this.scaleX;
    },

    setHeight: function (height) {
        if (!height) height = 0;
        let scale;
        if(height > 0 && this.height > 0) {
            scale = height / this.height;
        }

        this.set('height', height);
        this.item(1).set('height', height);
        if (!this.allowEdit) {
            this.item(0).set('maxHeight', height);
        }

        if (this.allowEdit && !this.noScaleTextWithBox && scale) {
            this.forceFontSize(false);
            this.item(0).set('top', this.item(0).top * scale);
            this.textTransformed = true;
            this.setText(this.getText());
            this.setEditedProp?.('innerText');
        }
    },

    getHeight: function () {
        return this.height * this.scaleY;
    },

    getTextAngle: function () {
        return this.item(0).angle;
    },

    getTextLeft: function () {
        return this.item(0).left;
    },

    getTextTop: function () {
        return this.item(0).top;
    },

    setMinSizePx: function (size) {
        this.minSizePx = size;
        if (this.allowEdit && this.forcedFontSize) {
            return;
        }

        this.item(0).set('minFontSize', size);
    },

    setMaxSizePx: function (size) {
        this.maxSizePx = size;
        if (this.allowEdit && this.forcedFontSize) {
            return;
        }
        this.item(0).set('maxFontSize', size);
    },

    setMultiline: function (multiline) {
        this.multiline = multiline;
        this.item(0).set('multiline', multiline);
    },

    setVerticalText: function (verticalText) {
        // One char per line would lay out as a paragraph per char inside a text shape
        if (verticalText && this.textShape) {
            verticalText = false;
        }
        this.verticalText = verticalText;
        this.item(0).set('verticalText', verticalText);
        this.setText(this.getText());
    },

    setAllowEdit: function (allowEdit) {
        this.allowEdit = allowEdit;
        this.item(0).set('allowEdit', allowEdit);
        this.fire('object:dblclick');
    },

    setUseAsMask: function (useAsMask) {
        this.useAsMask = useAsMask;
    },

    setUseAsCutout: function (useAsCutout) {
        this.useAsCutout = useAsCutout;
    },

    setCaps: function (caps) {
        this.caps = caps;
        if (caps) {
            this.setText(this.getText().toUpperCase());
        }
    },

    getTextPosition: function (hAlign, vAlign) {
        const position = { top: 0, left: 0 };
        switch (vAlign) {
            case 'center':
                position.top = 0;
                break;
            case 'top':
                position.top = (this.getHeight() - this.item(0).height) / -2;
                break;
            case 'bottom':
                position.top = (this.getHeight() - this.item(0).height) / 2;
                break;
        }

        switch (hAlign) {
            case 'justify':
            case 'center':
                position.left = 0;
                break;
            case 'left':
                position.left = (this.getWidth() - this.item(0).width) / -2;
                break;
            case 'right':
                position.left = (this.getWidth() - this.item(0).width) / 2;
                break;
        }

        return position;
    },

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject: function (ctx) {
        if (this.item(0).textPath || this.item(0)._shapeMask) {
            // Text shape: item(0) spans the whole box and positions each line itself
            // "Draw on Path": item(0) must stay at the group's own origin (0,0) - the path's own
            //  coordinates (and pathScale/positionInPath in _renderTextAlongPath) are defined
            //  relative to that origin. The rectangle-based getTextPosition() below uses
            //  item(0).width/height, which is frozen/stale in path mode (see
            //  OpentypeIText._setWidthHeight's guard), so applying it here would offset the whole
            //  path's coordinate system on every render - this is what made the path visibly
            //  "move" whenever textAlign/textVerticalAlign changed while in path mode.
            this.item(0).set({ top: 0, left: 0 });
        } else if (!this.allowEdit) {
            // Update position of the text in the group
            const textPosition = this.getTextPosition(this.textAlign, this.textVerticalAlign);

            this.item(0).set({
                top: textPosition.top,
                left: textPosition.left
            });
        }

        // Render all the objects in the group
        this.callSuper('drawObject', ctx);
    },

    clone: function (callback) {
        // Create a new BoundedText object. Cloning the object using the fabric.js
        //  utility clone() doesn't work well. This is the recommended way to clone
        //  groups.
        const copy = new fabric.BoundedText({
            width: this.getWidth(),
            height: this.getHeight(),
            originX: 'center',
            originY: 'center',
            left: this.left,
            top: this.top,
            skewX: this.skewX,
            skewY: this.skewY,
            strokeDashArray: this.item(1).strokeDashArray,
            angle: this.angle,
            centeredRotation: true,
            Itext: this.Itext,

            lockSkewingX: this.lockSkewingX,
            lockSkewingY: this.lockSkewingY,
            lockScalingFlip: true,

            fontPath: this.fontPath,
            fontName: this.firstFontName || this.fontName,

            outlineColor: this.outlineColor,
            id: this.id,
            uuid: this.uuid,

            evented: this.evented,
            selectable: this.selectable,
            locked: this.locked,
            visible: this.visible,
            name: this.name,
            fontColorOption: this.fontColorOption,
            outlineColorOption: this.outlineColorOption,
            fontOption: this.fontOption,
            defaultValue: this.defaultValue,
            isPersonalizableText: this.isPersonalizableText,
            prefix: this.prefix,
            suffix: this.suffix,
            betweenCharacters: this.betweenCharacters,
            betweenWords: this.betweenWords,
            textAlign: this.textAlign,
            textVerticalAlign: this.textVerticalAlign,
            texture: this.texture,
            textureScale: this.textureScale,
            ligatures: this.ligatures,
            referenceId: this.referenceId,
            lineSpacing: this.lineSpacing,
            groupId: this.groupId,
            pageEpsId: this.pageEpsId,
            tracking: this.tracking,
            allowEdit: this.allowEdit,
            oldAllowEdit: this.oldAllowEdit,
            /*If the text uses the previous version of allowEdit (without a bounding box), these properties are left as null.
            Once they have a value, the new version is considered active.*/
            initCenterX: this.oldAllowEdit ? null : this.getTextLeft(),
            initCenterY: this.oldAllowEdit ? null : this.getTextTop(),
            initRotation: this.oldAllowEdit ? null : this.getTextAngle(),
            initFontSize: this.oldAllowEdit ? null : this.getFontSize(),
            /* --- */
            preventEditMode: this.preventEditMode,
            skipRectangleEventsOnInit: true,
            shadowType: this.shadowType,
            shadowOffset: this.shadowOffset,
            shadowAngle: this.shadowAngle,
            shadowBlur: this.shadowBlur,
            shadowColor: this.shadowColor,
            shadowColorOption: this.shadowColorOption || 1,
            shadowColorLibraryId : this.shadowColorLibraryId || null,
            sourceElement: this.sourceElement
        });

        copy.fontColorsMap = new Map([]);
        if (this.fontColorsMap) {
            if (this.fontColorsMap instanceof Array) {
                copy.fontColorsMap = new Map(this.fontColorsMap);
            } else if (typeof this.fontColorsMap === 'string') {
                try {
                    copy.fontColorsMap = new Map(JSON.parse(this.fontColorsMap));
                } catch {
                    // Ignore
                }
            } else {
                copy.fontColorsMap = this.fontColorsMap;
            }
        }

        copy.outlineColorsMap = new Map([]);
        if (this.outlineColorsMap) {
            if (this.outlineColorsMap instanceof Array) {
                copy.outlineColorsMap = new Map(this.outlineColorsMap);
            } else if (typeof this.outlineColorsMap === 'string') {
                try {
                    copy.outlineColorsMap = new Map(JSON.parse(this.outlineColorsMap));
                } catch {
                    // Ignore
                }
            } else {
                copy.outlineColorsMap = this.outlineColorsMap;
            }
        }
        
        copy.shadowColorsMap = new Map([]);
        if (this.shadowColorsMap) {
            if (this.shadowColorsMap instanceof Array) {
                copy.shadowColorsMap = new Map(this.shadowColorsMap);
            } else if (typeof this.shadowColorsMap === 'string') {
                try {
                    copy.shadowColorsMap = new Map(JSON.parse(this.shadowColorsMap));
                } catch {
                    // Ignore
                }
            } else {
                copy.shadowColorsMap = this.shadowColorsMap;
            }
        }

        copy.fontsMap = new Map([]);
        if (this.fontsMap) {
            if (this.fontsMap instanceof Array) {
                copy.fontsMap = new Map(this.fontsMap);
            } else if (typeof this.fontsMap === 'string') {
                try {
                    copy.fontsMap = new Map(JSON.parse(this.fontsMap));
                } catch {
                    // Ignore
                }
            } else {
                copy.fontsMap = this.fontsMap;
            }
        }

        copy.setMultiline(this.multiline);
        copy.setVerticalText(this.verticalText);
        copy.setMinSizePx(this.minSizePx);
        copy.setMaxSizePx(this.maxSizePx);
        copy.setFontFamily(this.getFontFamily());
        copy.setFontSize(this.item(0).fontSize);
        copy.setColor(this.getColor());
        copy.setStroke(this.item(1).stroke);
        copy.setStrokeWidth(this.item(1).strokeWidth);
        copy.setCursorColor(this.item(0).cursorColor);
        copy.setTextAlign(this.item(0).textAlign);
        copy.setTextVerticalAlign(this.item(0).textVerticalAlign);
        copy.setOutlineColor(this.getOutlineColor());
        copy.setOutlineWidth(this.getOutlineWidth());
        copy.setTrackingAmount(this.getTrackingAmount());
        copy.set('caps', this.caps);
        copy.set('fontLibraryId', this.fontLibraryId);
        copy.set('colorLibraryId', this.colorLibraryId);
        copy.set('zIndex', this.zIndex);
        copy.set('version', this.version);
        copy.item(0).set('version', this.version);
        copy.set('prefix', this.prefix);
        copy.set('suffix', this.suffix);
        copy.set('betweenCharacters', this.betweenCharacters);
        copy.set('betweenWords', this.betweenWords);
        copy.setAllowEdit(this.allowEdit);
        copy.setUseAsMask(this.useAsMask);
        copy.setUseAsCutout(this.useAsCutout);
        copy.setText(this.getText());
        copy.setShadowColor(this.getShadowColor());

        if (this.item(0).textPath) {
            // this.item(0).textPath is already a size-independent "unit path" (setTextPath()
            //  normalized it once when it was first set - see that method's comment), so
            //  normalize:false here to copy it over as-is instead of re-normalizing it against
            //  copy's own bounding box.
            copy.setTextPath(this.item(0).textPath, this.item(0).textPathAutoFit, this.item(0)._textPathDebug, {
                normalize: false
            });
        }

        if (this.shapeConfig) {
            copy.shapeConfig = {
                ...this.shapeConfig,
                shapeMap: Array.isArray(this.shapeConfig.shapeMap) ? [...this.shapeConfig.shapeMap] : []
            };
            copy.shapeOption = this.shapeOption;
            if (this.item(0)._shapeMask) {
                // The copy keeps its config, so a failure only leaves it as a rectangle until a shape is picked
                try {
                    copy._applyTextShape(this.item(0)._shapeMask, this.textShape);
                } catch (error) {
                    console.error(error);
                }
            }
        }

        if (callback) {
            callback(copy);
        } else {
            return copy;
        }
    },

    resetEditMode: function () {
        this.item(0).set('top', 0);
        this.item(0).set('left', 0);
        this.item(0).set('maxWidth', this.item(1).width);
        this.item(0).set('maxHeight', this.item(1).height);
        this.item(0).set('angle', 0);
        if (this.canvas) {
            this.canvas.requestRenderAll();
        }
    },

    /**
     * This enables edit mode to allow moving and zooming the vector within the element.
     * The only way to disable edit mode after using enableEditMode() is calling
     *  disableEditMode()
     */
    enableEditMode: function () {
        this._forcedEditMode = true;
        this.fire('object:dblclick');
    },

    disableEditMode: function () {
        this.fire('deselected');
    },

    /**
     * Compute the corrected X and Y displacement with the current object angle.
     * Converts a canvas-space distance vector into group-local coordinates by applying
     * an inverse rotation of -angle. Equivalent to the previous tan-based formula but
     * numerically stable at 90°/270° where Math.tan() diverges.
     *
     * @param {number} distanceX translation in the X axis
     * @param {number} distanceY translation in the Y axe
     */
    _correctOffset: function (distanceX, distanceY) {
        const angleRad = fabric.util.degreesToRadians(this.angle);
        const cos = Math.cos(angleRad);
        const sin = Math.sin(angleRad);

        // Inverse rotation by -angle: canvas space → group-local space
        const correctedX = distanceX * cos + distanceY * sin;
        const correctedY = -distanceX * sin + distanceY * cos;

        return {
            x: correctedX,
            y: correctedY
        };
    },

    getEditModeParameters() {
        return {
            offsetX: this._controlRectangle.left - this.left || 0,
            offsetY: this._controlRectangle.top - this.top || 0,
            scaleX: this._controlRectangle.scaleX || 1,
            scaleY: this._controlRectangle.scaleY || 1,
            angle: this._controlRectangle.angle || 0
        };
    },
    setTextOffset(offsetX, offsetY) {
        this.textTransformed = true;
        let newX = this.left + offsetX;
        let newY = this.top + offsetY;

        const constrainedPoint = constrainPositionToBoundingBox(this, this._controlRectangle, newX, newY);
        const distanceX = constrainedPoint.x - this.left;
        const distanceY = constrainedPoint.y - this.top;

        const result = this._correctOffset(distanceX, distanceY);

        this.item(0).set('left', result.x);
        this.item(0).set('top', result.y);

        this._controlRectangle.set({
            left: constrainedPoint.x,
            top: constrainedPoint.y
        });

        this._controlRectangle.setCoords();
    },
    setTextScale(scaleX, scaleY) {
        this.textTransformed = true;
        let scale = scaleX != 1 ? scaleX : scaleY; //Always scales proportionally

        if (this.multiline && this.item(0).splitText) {
            //If the text is multiline and split, we do not allow resizeing it.
            // It should only be split if it reaches the minimum font size.
            this._controlRectangle.scaleX = 1;
            this._controlRectangle.scaleY = 1;
            return;
        }

        const newFontSize = this.getFontSize() * scale;
        if (newFontSize < this.minSizePx || newFontSize > this.maxSizePx) {
            this._controlRectangle.scaleX = 1;
            this._controlRectangle.scaleY = 1;
            return;
        }

        let width = this.item(0).width;
        let height = this.item(0).height;
        if (this.item(0).text === '') {
            let { textWidth, textHeight } = this.item(0)._getTextMetrics('A', this.getTrackingAmount());
            width = textWidth;
            height = textHeight;
        }
        var scaleLimit = constrainDimensionToBoundingBox(this.item(1), this.item(0), width, height);

        if (scale > scaleLimit.maxScale) {
            this._controlRectangle.scaleX = 1;
            this._controlRectangle.scaleY = 1;
            return;
        }

        this._controlRectangle.scaleX = 1;
        this._controlRectangle.scaleY = 1;


        this.forceFontSize(newFontSize);

        this._controlRectangle.set('width', this.item(0).width);
        this._controlRectangle.set('height', this.item(0).height);
        this._controlRectangle.setCoords();
    },
    setTextRotation(angle) {
        this.textTransformed = true;
        // Rotate the element in steps
        this._controlRectangle.angle = Math.ceil(angle / this.rotationStep) * this.rotationStep;

        var constrainRotation = constrainRotationToBoundingBox(this, this._controlRectangle);

        if (constrainRotation.minRotationDelta == 0 || constrainRotation.maxRotationDelta == 0) {
            this._controlRectangle.angle = this.lastAngle;
        }
        this.lastAngle = this._controlRectangle.angle;

        this.item(0).set('angle', this._controlRectangle.angle - this.angle);
        this._controlRectangle.setCoords();
    },
    getTextAsMask() {
        const node = document.createElement('canvas');
        document.body.appendChild(node);
        const canvas = new fabric.StaticCanvas(node);
        canvas.skipOffscreen = false;
        canvas.width = this.getWidth();
        canvas.height = this.getHeight();
        const text = this.clone();
        text.excludeFromUpdateLock = true;
        text.setColor('#000000');
        text.setStroke('#000000');
        text.set('originX', 'left');
        text.set('originY', 'top');
        text.set('left', 0);
        text.set('top', 0);
        canvas.add(text);

        const maskDataUrl = canvas.toDataURL({
            format: 'png',
            quality: 0.8
        });

        canvas.dispose();
        node.remove();

        return maskDataUrl;
    },

    setInitPositionAndSize(left, top, fontSize) {
        this.item(0).left = left;
        this.item(0).top = top;
        this.forceFontSize(fontSize);  
        this.textTransformed = true;
        this.setText(this.getText());
    }
});
